import fetchData from "@/utils/fetchData";

// The user's saved makes, kept in their account
const request = (endpoint, body = {}) =>
  fetchData(`makes/${endpoint}`, body, false, false, false);

export default {
  name: "makes",
  namespaced: true,
  state: {
    list: [],
    search: "",
    loading: false,
    error: "",
  },
  mutations: {
    SET_LIST(state, payload) {
      state.list = payload;
    },
    SET_SEARCH(state, payload) {
      state.search = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
    UPDATE_MAKE(state, { id, changes }) {
      state.list = state.list.map((make) =>
        make.id === id ? { ...make, ...changes } : make
      );
    },
  },
  actions: {
    async fetchList({ commit, state }, search = state.search) {
      commit("SET_SEARCH", search);
      commit("SET_LOADING", true);
      commit("SET_ERROR", "");
      const { response } = await request("list", { search });
      // Ignore answers to searches that have since changed
      if (search !== state.search) return;
      if (response.status === 201 && Array.isArray(response.result?.makes)) {
        commit("SET_LIST", response.result.makes);
      } else {
        commit("SET_ERROR", "We couldn't load your makes, please try again");
      }
      commit("SET_LOADING", false);
    },
    async open({ commit, dispatch }, id) {
      commit("SET_ERROR", "");
      const { response } = await request("get", { id });
      const make = response.result?.make;
      if (response.status !== 201 || !make) {
        commit("SET_ERROR", "We couldn't open that make");
        return false;
      }
      await dispatch(
        "changePrompt",
        { prompt: make.prompt, force: true },
        {
          root: true,
        }
      );
      await dispatch("result/showSavedMake", make, { root: true });
      return true;
    },
    async rename({ commit }, { id, title }) {
      const { response } = await request("rename", { id, title });
      if (response.status === 201) {
        commit("UPDATE_MAKE", {
          id,
          changes: { title: response.result.title },
        });
      }
    },
    async unshare({ commit }, id) {
      const { response } = await request("unshare", { id });
      if (response.status === 201) {
        commit("UPDATE_MAKE", { id, changes: { shared: false } });
      }
    },
    async remove({ commit, state }, id) {
      await request("delete", { id });
      commit(
        "SET_LIST",
        state.list.filter((make) => make.id !== id)
      );
    },
  },
  getters: {},
};
